<div class="case-asset-info-card" [class.print-mode]="printMode">
  <!-- Header with tabs and action icons -->
  <div class="card-header" *ngIf="!printMode">
    <div class="tabs-container">
      <button 
        class="tab" 
        [class.active]="activeTab() === 'case'"
        (click)="setActiveTab('case')">
        {{ 'case_asset_info_tab_case' | translate }}
      </button>
      <button 
        class="tab" 
        [class.active]="activeTab() === 'asset'"
        (click)="setActiveTab('asset')">
        {{ 'case_asset_info_tab_asset' | translate }}
      </button>
    </div>
    <div class="header-actions">
      <button class="action-icon" (click)="onCloseClick()" [attr.aria-label]="'case_asset_info_close' | translate">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Content area -->
  <div class="card-content" [class.print-mode-content]="printMode">
    <!-- Print Mode: Show both sections side by side -->
    <ng-container *ngIf="printMode">
      <!-- Case Section -->
      <div class="content-section print-section" *ngIf="caseData">
        <div class="data-row highlight-row">
          <div class="data-item">
            <span class="data-label">{{ 'case_asset_info_case_id' | translate }}:</span>
            <span class="data-value">{{ caseData.caseId }}</span>
          </div>
        </div>
        <div class="data-row">
          <div class="data-item">
            <span class="data-label">{{ 'case_asset_info_date' | translate }}:</span>
            <span class="data-value">{{ caseData.date }}</span>
          </div>
        </div>
        <div class="data-row">
          <div class="data-item">
            <span class="data-label">{{ 'case_asset_info_auto_update' | translate }}:</span>
            <span class="data-value">{{ caseData.autoUpdate }}</span>
          </div>
        </div>
        <div class="data-row">
          <div class="data-item">
            <span class="data-label">{{ 'case_asset_info_avm_model' | translate }}:</span>
            <span class="data-value">{{ caseData.avmModel }}</span>
          </div>
        </div>
      </div>

      <!-- Asset Section -->
      <div class="content-section print-section" *ngIf="assetData">
        <div class="data-row highlight-row" *ngIf="assetData.plotUuid">
          <div class="data-item">
            <span class="data-label">{{ 'case_asset_info_parcel_id' | translate }}:</span>
            <span class="data-value">{{ assetData.plotUuid }}</span>
          </div>
        </div>
        <div class="data-row" *ngIf="assetData.nib">
          <div class="data-item">
            <span class="data-label">{{ 'case_asset_info_nib' | translate }}:</span>
            <span class="data-value">{{ assetData.nib }}</span>
          </div>
        </div>
        <div class="data-row" *ngIf="assetData.nomor">
          <div class="data-item">
            <span class="data-label">{{ 'case_asset_info_nomor' | translate }}:</span>
            <span class="data-value">{{ assetData.nomor }}</span>
          </div>
        </div>
        <div class="data-row" *ngIf="assetData.address">
          <div class="data-item">
            <span class="data-label">{{ 'case_asset_info_address' | translate }}:</span>
            <span class="data-value">{{ assetData.address }}</span>
          </div>
        </div>
        <div class="data-row" *ngIf="assetData.center">
          <div class="data-item">
            <span class="data-label">{{ 'case_asset_info_coordinates' | translate }}:</span>
            <span class="data-value">{{ assetData.center[0] }}, {{ assetData.center[1] }}</span>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Normal Mode: Show active tab content -->
    <ng-container *ngIf="!printMode">
      <!-- Case Tab Content -->
      <div class="content-section" *ngIf="activeTab() === 'case' && caseData">
        <div class="data-row highlight-row">
          <div class="data-item">
            <span class="data-label">{{ 'case_asset_info_case_id' | translate }}:</span>
            <span class="data-value">{{ caseData.caseId }}</span>
          </div>
        </div>
        <div class="data-row">
          <div class="data-item">
            <span class="data-label">{{ 'case_asset_info_date' | translate }}:</span>
            <span class="data-value">{{ caseData.date }}</span>
          </div>
        </div>
        <div class="data-row">
          <div class="data-item">
            <span class="data-label">{{ 'case_asset_info_auto_update' | translate }}:</span>
            <span class="data-value">{{ caseData.autoUpdate }}</span>
          </div>
        </div>
        <div class="data-row">
          <div class="data-item">
            <span class="data-label">{{ 'case_asset_info_avm_model' | translate }}:</span>
            <span class="data-value">{{ caseData.avmModel }}</span>
          </div>
        </div>
      </div>

      <!-- Asset Tab Content -->
      <div class="content-section" *ngIf="activeTab() === 'asset' && assetData">
        <div class="data-row highlight-row" *ngIf="assetData.plotUuid">
          <div class="data-item">
            <span class="data-label">{{ 'case_asset_info_parcel_id' | translate }}:</span>
            <span class="data-value">{{ assetData.plotUuid }}</span>
          </div>
        </div>
        <div class="data-row" *ngIf="assetData.nib">
          <div class="data-item">
            <span class="data-label">{{ 'case_asset_info_nib' | translate }}:</span>
            <span class="data-value">{{ assetData.nib }}</span>
          </div>
        </div>
        <div class="data-row" *ngIf="assetData.nomor">
          <div class="data-item">
            <span class="data-label">{{ 'case_asset_info_nomor' | translate }}:</span>
            <span class="data-value">{{ assetData.nomor }}</span>
          </div>
        </div>
        <div class="data-row" *ngIf="assetData.address">
          <div class="data-item">
            <span class="data-label">{{ 'case_asset_info_address' | translate }}:</span>
            <span class="data-value">{{ assetData.address }}</span>
          </div>
        </div>
        <div class="data-row" *ngIf="assetData.center">
          <div class="data-item">
            <span class="data-label">{{ 'case_asset_info_coordinates' | translate }}:</span>
            <span class="data-value">{{ assetData.center[0] }}, {{ assetData.center[1] }}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

